import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF8F4] px-5">
      <form onSubmit={submit} className="card-soft w-full max-w-sm space-y-5 p-8" data-testid="admin-login-form">
        <Link to="/"><img src="/logo.webp" alt="Violet Psychotherapy" className="mx-auto h-16 w-auto" /></Link>
        <h1 className="text-center text-3xl text-[#22304A]">Admin sign in</h1>
        <div>
          <label htmlFor="admin-email" className="text-sm font-medium">Email</label>
          <input id="admin-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full rounded-xl border border-[#B9A9D8]/70 bg-white px-4 py-3" data-testid="admin-email-input" />
        </div>
        <div>
          <label htmlFor="admin-password" className="text-sm font-medium">Password</label>
          <input id="admin-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full rounded-xl border border-[#B9A9D8]/70 bg-white px-4 py-3" data-testid="admin-password-input" />
        </div>
        {error && <p role="alert" className="text-sm text-[#991B1B]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
};
